import { Mappable } from '../Mappable';
import { Location } from './Location';

export class SuggestionsResponse extends Mappable {
  locations = [];
  boxes = [];

  constructor(locations = [], boxes = []) {
    super();

    this.locations = locations;
    this.boxes = boxes;
  }

  static map(data) {
    if (!data?.suggestions) return new SuggestionsResponse();

    const locations = data.suggestions.location?.map(item => Location.map(item));
    const boxes = data.suggestions.box;

    return new SuggestionsResponse(locations, boxes);
  }
}
